import { httpClient } from '@/services/http/httpClient'

export type Comment = {
  id: string
  projectId: string
  title: string
  comment: string
  ownerId: string
  attachmentUrl: string | null
  subCommentId: string | null
  createdAt: string
  updatedAt: string
  owner: {
    id: string
    name: string
    email: string
    image: string | null
  }
  replies?: Comment[]
}

export type GetCommentsResponse = Comment[]

export async function getComments(projectId: string) {
  const { data } = await httpClient.get<GetCommentsResponse>(
    `/projects/project-comments/${projectId}`,
  )
  return data
}
